import AccessibilityOutlineIcon from 'icons/accessibility-outline.svg';
import AccessibilityIcon from 'icons/accessibility.svg';
import AgendaIconOutline from 'icons/agenda-outline.svg';
import AgendaIcon from 'icons/agenda.svg';
import ChatOutlineIcon from 'icons/chat-outline.svg';
import ChatIcon from 'icons/chat24.svg';
import DocOutlineIcon from 'icons/doc-outline.svg';
import DocIcon from 'icons/doc.svg';
import TimeOutlineIcon from 'icons/time-outline.svg';
import TimeIcon from 'icons/time.svg';
import UnionOutlineIcon from 'icons/union-outline.svg';
import UnionIcon from 'icons/union.svg';
import UserOutlineIcon from 'icons/user-outline.svg';
import UserIcon from 'icons/user.svg';

import { SpecialistRole } from 'services/specialist';

import { MenuItemNav } from './types';

export const items: MenuItemNav[] = [
  {
    key: 'cp-dashboard',
    title: 'SIDEBAR_MENU.BUTTON.CP_DASHBOARD',
    baseUrls: ['/care-provider/dashboard'],
    redirectUrl: '/care-provider/dashboard',
    icon: UnionOutlineIcon,
    iconSelected: UnionIcon,
    hasNotification: false,
    allowedRoles: [SpecialistRole.CP],
  },
  {
    key: 'dashboard',
    title: 'SIDEBAR_MENU.BUTTON.TC_DASHBOARD',
    baseUrls: ['/therapy-companion/dashboard'],
    redirectUrl: '/therapy-companion/dashboard',
    icon: UnionOutlineIcon,
    iconSelected: UnionIcon,
    hasNotification: false,
    allowedRoles: [SpecialistRole.TC],
  },
  {
    key: 'profile',
    title: 'SIDEBAR_MENU.BUTTON.PROFILE',
    baseUrls: ['/care-provider/info'],
    redirectUrl: '/care-provider/info',
    icon: UserOutlineIcon,
    iconSelected: UserIcon,
    hasNotification: false,
    allowedRoles: [SpecialistRole.TC, SpecialistRole.CP],
  },
  {
    key: 'agenda',
    title: 'SIDEBAR_MENU.BUTTON.AGENDA',
    baseUrls: ['/care-provider/agenda'],
    redirectUrl: '/care-provider/agenda/calendar',
    icon: AgendaIconOutline,
    iconSelected: AgendaIcon,
    hasNotification: false,
    allowedRoles: [SpecialistRole.CP],
  },
  {
    key: 'patients',
    title: 'SIDEBAR_MENU.BUTTON.PATIENTS',
    baseUrls: ['/care-provider/patient-list', '/enduser/'],
    redirectUrl: '/care-provider/patient-list',
    icon: AccessibilityOutlineIcon,
    iconSelected: AccessibilityIcon,
    hasNotification: false,
    allowedRoles: [SpecialistRole.TC, SpecialistRole.CP],
  },
  {
    key: 'chat',
    title: 'SIDEBAR_MENU.BUTTON.CHAT',
    baseUrls: ['/care-provider/chat'],
    redirectUrl: '/care-provider/chat',
    icon: ChatOutlineIcon,
    iconSelected: ChatIcon,
    hasNotification: false,
    allowedRoles: [SpecialistRole.TC, SpecialistRole.CP],
  },
  {
    key: 'sessions-history',
    title: 'CPPLATFORM.MENU.SESSIONSPAYMENTS',
    baseUrls: ['/care-provider/session-history', '/care-provider/payments'],
    redirectUrl: '/care-provider/session-history',
    icon: TimeOutlineIcon,
    iconSelected: TimeIcon,
    hasNotification: false,
    allowedRoles: [SpecialistRole.CP],
  },
  {
    key: 'library',
    title: 'SIDEBAR_MENU.BUTTON.LIBRARY',
    baseUrls: ['/content-library'],
    redirectUrl: '/content-library',
    icon: DocOutlineIcon,
    iconSelected: DocIcon,
    hasNotification: false,
    allowedRoles: [SpecialistRole.TC, SpecialistRole.CP],
    allowedGeoCodes: ['BR'],
  },
];
